import {IntlShape} from "react-intl";

/**
 * Методы для работы с react-intl для локализации
 */

/**
 * Провайдер для сообщений в текущей локале (react-intl)
 *
 * @memberOf components.common.util.intl
 * @type {Object} Объект-провайдер для локализации
 */
let intl: IntlShape;

type TIntlChangerProvider = (locale: string) => void;

/**
 * Переменная для хранения функции замены текущей локали
 *
 * @memberOf components.common.util.intl
 * @type {function}
 */
let intlChanger: TIntlChangerProvider;

/**
 * дефолтная локаль
 * @returns {string}
 */
export const getDefaultLocale = (): string => {
  const locales = ["ru", "en"];
  return locales[0];
};

/**
 * Установка провайдера извне
 *
 * @param {Object} intlProvider - Объект-провайдер для локализации
 * @returns {void}
 */
export function setIntlProvider(intlProvider: IntlShape): void {
  intl = intlProvider;
}

/**
 * Установка глобальной функции замены локали в провайдере
 *
 * @param {Function} intlChangerProvider - функция
 * @returns {void}
 */
export function setIntlChanger(intlChangerProvider: TIntlChangerProvider): void {
  intlChanger = intlChangerProvider;
}

/**
 * Функция динамической замены текущей локали
 *
 * @param {string} locale - локаль
 * @returns {void}
 */
export function setCurrentLocale(locale: string): void {
  intlChanger(locale);
}

/**
 * Получение сообщения в текущей локали
 *
 * @param {string} id - ID сообщения
 * @param {void|Object} values  - Значения для подстановки
 * @returns {string} Строка перевода
 */
export function t(id: string, values?: Record<string, string | number | undefined>): string {
  return intl ? intl.formatMessage({id, defaultMessage: id}, values) : "";
}

/**
 * Получение сообщения об ошибке в текущей локали
 *
 * @param {string} id - ID сообщения
 * @param {void|Object} error  - Значение ошибки для подстановки
 * @returns {string} Строка перевода
 */
export function tError(id: string, error?: string, params?: Record<string, string | number | undefined>): string {
  if (error && intl.messages[error]) {
    return t(id, {error: t(error, params)});
  }
  return t(id, {error: t("ild.unknown.error")});
}

/**
 * Получение текущей локали
 *
 * @returns {string} Текущая локаль ru/en
 */
export function getCurrentLocale(): string {
  return intl.locale;
}
